import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { sendNowhere } from "../../view.ts";
import { type Action } from "../../app-store.ts";
import {
  toColor as toCategoryColor,
  forceCategoryStyles,
} from "../../../../models/force-category.ts";
import { type ForceNote } from "../../../../models/note/force.ts";
import { type ForceConnectionNote } from "../../../../models/note/force-connection.ts";
import * as Styles from "../../../styles.ts";
import { Ulid } from "../../../../models/ulid.ts";
import { type ActivateNodeEvent } from "../radial-force-network.ts";

// Components
import "../donut-chart.ts";
import "../../dui/tabs/dui-tabs.ts";
import "../../dui/tabs/dui-tabs-list.ts";
import "../../dui/tabs/dui-tab.ts";
import "../../dui/tabs/dui-tabs-panel.ts";
import "../radial-force-network.ts";

@customElement("force-vis-panel")
export class ForceVisPanel extends LitElement {
  static override styles = [Styles.base, forceCategoryStyles];

  @property({ type: String })
  accessor heading = "Connect Forces";

  @property()
  accessor forces: Map<Ulid, ForceNote> = new Map();

  @property()
  accessor forceConnections: Map<string, ForceConnectionNote> = new Map();

  @property({ type: String })
  accessor project: string | undefined = undefined;

  send = sendNowhere<Action>;

  onActivateForceNode = (event: ActivateNodeEvent) => {
    this.send({
      type: "set-canvas-view",
      canvasView: "force-edit",
      slug: event.detail,
    });
  };

  override render() {
    return html`
      <radial-force-network
        @activate-node="${this.onActivateForceNode}"
        .nodes="${Array.from(this.forces.values()).map((f) => ({
          id: f.slug,
          title: f.title,
          content: f.content,
          category: f.meta.category,
        }))}"
        .links="${Array.from(this.forceConnections.values()).map((c) => ({
          id: c.slug,
          title: c.title,
          content: c.content,
          source: c.meta.source,
          target: c.meta.target,
          strength: c.meta.strength,
        }))}"
        .categoryColor="${toCategoryColor}"
      ></radial-force-network>
    `;
  }
}
